import Store from '@kaidam/fc-shared/src/frontend/store'
import { Router } from 'router5'

import { reducer as auth } from './modules/auth'
import { reducer as fileupload } from './modules/fileupload'
import { reducer as knowledgebase } from './modules/knowledgebase'
import { reducer as booking } from './modules/booking'
import { reducer as project } from './modules/project'
import { reducer as support } from './modules/support'
import { reducer as coconut_ppc_payments } from './modules/coconut_ppc_payments'
import { reducer as rbac } from './modules/rbac'
import { reducer as crm } from './modules/crm'
import { reducer as job } from './modules/job'
import { reducer as filestore } from './modules/filestore'
import { reducer as astonish } from './modules/astonish'
import { reducer as nopress } from './modules/nopress'
import { reducer as marketing } from './modules/marketing'

const appReducers = {
  auth,
  fileupload,
  knowledgebase,
  booking,
  project,
  support,
  coconut_ppc_payments,
  rbac,
  crm,
  job,
  filestore,
  astonish,
  nopress,
  marketing,
}

interface StoreProps {
  router: Router<Record<string, any>>,
  initialState: Record<string, any>,
}

const StoreFactory = ({
  router,
  initialState = {},
}: StoreProps): any => {
  
  return Store({
    router,
    initialState,
    reducers: appReducers,
  })
}

export default StoreFactory